export const WHATSAPP_NUMBER = "4917687870011";
export const WHATSAPP_MESSAGE = "Hi! I'd like a free sample video for my business 🚀";

export const getWhatsAppLink = (message?: string) => {
  const msg = encodeURIComponent(message || WHATSAPP_MESSAGE);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
};
